exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.video-exp[data-v-67515e0c] {\n    z-index: 2147483647;\n}\n", ""]);

// exports
